import * as React from "react";
import { useEffect, useState } from "react";
import "./MethodTitle.scss";
import MethodArrow from "../MethodArrow/MethodArrow";
import PropTypes from "prop-types";

const MethodTitle = (props) => {
  const [title, setTitle] = useState(null);

  useEffect(() => {
    setTitle(props.title.split(" "));
  }, [props]);

  return (
    <div className="method-desktop-title">
      <div>{title && title[0] + " " + title[1]}</div>
      <div>{title && title[2]}</div>
      <MethodArrow orientation={"horizontal"} direction={"right"} />
    </div>
  );
};

MethodTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default MethodTitle;
